import { useEffect, useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import api from '../../../../../../../../common/utils/api';
import GenericObject from '../../../../../../../../typesAdditional/GenericObject';

interface Props {
    data: GenericObject;
    formPrefix: string;
    rawOnChange: (field: string, value: any) => void;
}

const PlaceOfBirthAutocomplete = (props: Props) => {
    const { data, formPrefix, rawOnChange } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [places, setPlaces] = useState([]);

    const [value, setValue] = useState('0');

    const selectedLegalId = data[formPrefix]?.place_of_birth_legal_id ?? '';
    const setSelectedLegalId = (town: string) => {
        rawOnChange(formPrefix + '.place_of_birth_legal_id', town);

        if (town) {
            api.request('/towns_countries/' + town).then((res: any) => {
                rawOnChange(formPrefix + '.placeOfBirthName', res?.name);
            });
        } else {
            rawOnChange(formPrefix + '.placeOfBirthName', '');
        }
    };

    useEffect(() => {
        setIsLoading(true);

        const timeout = setTimeout(() => {
            api.request('/towns_countries/search', 'GET', { query: (selectedLegalId.length && value === '0') ? selectedLegalId : value }).then((res: any) => {
                setPlaces(res);
                setIsLoading(false);
            });
        }, 250);

        return () => clearTimeout(timeout);
    }, [selectedLegalId, value]);

    const onChange = (_e: any, option?: any) => {
        setSelectedLegalId(option?.value ?? '');
    };

    const onInputChange = (e: any) => {
        if (!e) {
            return;
        } else if (e.target.value === undefined) {
            setSelectedLegalId('');
        }

        setValue(e.target.value === 0 ? '0' : e.target.value);
    };

    const options = places.map((town: any) => {
        return {
            name: town.name + (town.province ? (' (' + town.province.abbreviation + ')') : ''),
            value: town.legalId
        };
    });

    const selectedOption = options.find((t: any) => t.value === selectedLegalId) ?? null;

    return (
        <Autocomplete
            onChange={onChange}
            onInputChange={onInputChange}
            open={isOpen}
            style={{flex:2, marginBottom: '12px'}}
            onOpen={() => {
                setIsOpen(true);
            }}
            onClose={() => {
                setIsOpen(false);
            }}
            fullWidth
            getOptionSelected={(option1, option2) => option1.value === option2.value}
            getOptionLabel={(option) => option.name}
            options={options}
            loading={isLoading}
            clearText='Rimuovi'
            closeText='Chiudi'
            openText='Apri'
            loadingText='Caricamento...'
            value={selectedOption}
            noOptionsText={!value?.length ? 'Inserisci il nome del paese' : 'Nessun risultato trovato'}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Luogo di nascita'
                    variant='outlined'
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color='inherit' size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default PlaceOfBirthAutocomplete;
